import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

var src = ""
if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent))
	src = "wap_"
const router = new Router({
	mode: 'history',
	scrollBehavior: () => ({ y: 0 }),
	routes: [{
		path: "/",
		component: (resolve) => require(['@/view/'+src+'index.vue'],resolve),
	},{
		path: "/about/1.html",
		component: (resolve) => require(['@/view/'+src+'about_1.vue'],resolve),
	},{
		path: "/about/2.html",
		component: (resolve) => require(['@/view/'+src+'about_2.vue'],resolve),
	},{
		path: "/about/3.html",
		component: (resolve) => require(['@/view/'+src+'about_3.vue'],resolve),
	},{
		path: "/about/4.html",
		component: (resolve) => require(['@/view/'+src+'about_4.vue'],resolve),
	},{
		path: "/about/5.html",
		component: (resolve) => require(['@/view/'+src+'about_5.vue'],resolve),
	},{
		path: "/about/6.html",
		component: (resolve) => require(['@/view/'+src+'about_6.vue'],resolve),
	}]
})

export default router